import * as Models from 'models';

export function getVerticalNeighborPosition(relationId: string, parent: Models.ColumnRelationMap): number {
  const parentRelationsIds = parent.get('relationIds');
  const relationPosition = parentRelationsIds.indexOf(relationId);
  const isRelationLast = parentRelationsIds.size - 1 === relationPosition;

  return isRelationLast ? relationPosition - 1 : relationPosition + 1;
}
